export default __webpack_public_path__ + "static/media/chezledocteur.e67f232b.svg";